/**
 * Whether the owner closed the initial-order note with its X: then it stays closed on every page of the Games tab, on
 * later visits too, until its icon opens it again. Kept in this browser. A storage that cannot be read reads as not
 * closed, and one that cannot be written keeps the choice for this visit only.
 */
const KEY = 'ows.games.initial-order-note.closed';

export const readInitialOrderNoteClosed = (): boolean => {
  try {
    return window.localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
};

export const writeInitialOrderNoteClosed = (closed: boolean): void => {
  try {
    if (closed) window.localStorage.setItem(KEY, '1');
    else window.localStorage.removeItem(KEY);
  } catch {
    // Not kept: the choice holds for this visit only.
  }
};
